import { FaInstagram } from "react-icons/fa";
import { FaMapPin } from "react-icons/fa6";

export default function Footer() {
    return (
        <footer className="bg-white rounded-lg shadow  m-4">
            <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
                <div className=" md:flex md:items-center md:flex-row md:justify-between  flex flex-col justify-center items-center">
                    <a href="https://dotserramenti.it/" className="mb-4 sm:mb-0">
                        <img src="./DOTSerramenti_logo.png" className="h-20" alt="DotSerramenti Logo" />
                    
                    </a>
                    <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
                        <li>
                            <a href="/chi-siamo" className="hover:underline me-4 md:me-6">Chi siamo</a>
                        </li>
                        <li>
                            <a href="/privacy" className="hover:underline me-4 md:me-6">Privacy Policy</a>
                        </li>
                        <li>
                            <a href="/contatti" className="hover:underline">Contatti</a>
                        </li>
                    </ul>
                    <a href="https://www.instagram.com/dot_serramenti?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                className="flex items-center text-gray-500 sm:mb-0 dark:text-gray-400 p-1"><FaInstagram />&nbsp;@dot_serramenti</a>
                        </div>
                    <div className="flex items-center text-center justify-center text-sm text-gray-500 sm:text-center dark:text-gray-400"><FaMapPin />Via XX settembre 43, Desio</div>
                <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
                <span className="block text-sm text-gray-500 sm:text-center dark:text-gray-400">© {new Date().getFullYear()} <a href="https://dotserramenti.it/" 
                className="hover:underline">DOT Serramenti srl</a>. P.IVA: 13781650968 - Tutti i diritti sono riservati.</span>
            </div>
        </footer>


    );

}
